"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LOAN_TERMS_WEBSITE_URL = exports.WIDGET_MESSAGES = exports.EMPTY = exports.MATCH = exports.NO_MATCH = exports.APP_MESSAGES = exports.BANK_STATEMENT_MBS = exports.BANK_STATEMENT_PROVIDER_SKIP = exports.BANK_STATEMENT_PROVIDER_SUPPORT = exports.BANK_STATEMENT_MANUAL = exports.BANK_STATEMENT_PROVIDER_MONO = exports.BANK_STATEMENT_PROVIDER_OKRA = exports.PLAY_STORE_URL = exports.MAXIMUM_LOAN_VALUE = exports.MINIMUM_LOAN_VALUE = exports.LOAN_AMOUNT_STEP = exports.DEFAULT_LOAN_VALUE = exports.DEFAULT_ERROR_MESSAGE = exports.FONT_CONFIG = exports.FONT_FAMILY = exports.NAIRA_SYMBOL = exports.BREAK_POINT_WIDTH = exports.BUTTON_WIDTH = exports.APP_VERSION = exports.VERSION_PATCH = void 0;
const react_native_1 = require("react-native");
const react_native_config_1 = __importDefault(require("react-native-config"));
const config_1 = require("../../web/config");
// App Version Patch
exports.VERSION_PATCH = 9;
// App Version
exports.APP_VERSION = react_native_1.Platform.OS === 'web' ? `${config_1.VER_NAME}.${exports.VERSION_PATCH}` : `${react_native_config_1.default.VER_NAME}.${exports.VERSION_PATCH}`;
// Style
exports.BUTTON_WIDTH = '91%';
exports.BREAK_POINT_WIDTH = 800;
// Naira symbol
exports.NAIRA_SYMBOL = '\u20A6';
exports.FONT_FAMILY = react_native_1.Platform.OS === 'web' ? 'Noto Sans' : 'NotoSans';
exports.FONT_CONFIG = {
    web: {
        regular: {
            fontFamily: exports.FONT_FAMILY,
            fontWeight: 'normal',
        },
        medium: {
            fontFamily: exports.FONT_FAMILY,
            fontWeight: 'normal',
        },
        light: {
            fontFamily: exports.FONT_FAMILY,
            fontWeight: 'normal',
        },
        thin: {
            fontFamily: exports.FONT_FAMILY,
            fontWeight: 'normal',
        },
    },
    ios: {
        regular: {
            fontFamily: exports.FONT_FAMILY,
            fontWeight: 'normal',
        },
        medium: {
            fontFamily: exports.FONT_FAMILY,
            fontWeight: 'normal',
        },
        light: {
            fontFamily: exports.FONT_FAMILY,
            fontWeight: 'normal',
        },
        thin: {
            fontFamily: exports.FONT_FAMILY,
            fontWeight: 'normal',
        },
    },
    android: {
        regular: {
            fontFamily: exports.FONT_FAMILY,
            fontWeight: 'normal',
        },
        medium: {
            fontFamily: exports.FONT_FAMILY,
            fontWeight: 'normal',
        },
        light: {
            fontFamily: exports.FONT_FAMILY,
            fontWeight: 'normal',
        },
        thin: {
            fontFamily: exports.FONT_FAMILY,
            fontWeight: 'normal',
        },
    },
};
// Text messages
exports.DEFAULT_ERROR_MESSAGE = 'There was an error.';
// Loan Application
exports.DEFAULT_LOAN_VALUE = 500000;
exports.LOAN_AMOUNT_STEP = 100000;
exports.MINIMUM_LOAN_VALUE = 100000;
exports.MAXIMUM_LOAN_VALUE = 10000000;
// store link
exports.PLAY_STORE_URL = react_native_1.Platform.OS === 'web'
    ? 'https://play.google.com/store/apps/details?id=com.lendigo.app'
    : 'market://details?id=com.lendigo.app';
// Bank statement providers
exports.BANK_STATEMENT_PROVIDER_OKRA = 'PROVIDER_OKRA';
exports.BANK_STATEMENT_PROVIDER_MONO = 'PROVIDER_MONO';
exports.BANK_STATEMENT_MANUAL = 'MANUAL_STATEMENT';
exports.BANK_STATEMENT_PROVIDER_SUPPORT = 'PROVIDER_SUPPORT';
exports.BANK_STATEMENT_PROVIDER_SKIP = 'PROVIDER_SKIP';
exports.BANK_STATEMENT_MBS = 'PROVIDER_MY_BANK_STATEMENT';
// app provider messages
exports.APP_MESSAGES = {
    BANK_CONNECTED_SUCCESS: 'Account connected successfully.',
    LAST_PROVIDER_FAIL_CONNECT: `We could not connect you with <<lastProviderName>>. Dont worry, we will provide another way for you to connect.`,
    PRIMARY_BANK_NOT_SUPPORTED: 'You may be unable to submit your bank statement now because your primary bank account is not supported. Kindly add another primary account of a supported bank or contact us for support.',
    CONNECTION_PROVIDER_TIMEOUT: 'It’s taking too long to connect with your bank to get your statement at the moment. Kindly try again in a few minutes. Feel free to contact us for support.',
    TRY_NEXT_PROVIDER: `We are unable to connect with your bank through <<lastProviderName>> to get your statement at the moment. Kindly use <<nextProviderName>> to securely provide your statement. Feel free to contact us for support.`,
    TRY_AGAIN_PROVIDER: 'We are unable to connect with your bank to get your statement at the moment. Kindly try again in a few minutes. Feel free to contact us for support.',
    WRONG_ACCOUNT_CONNECTED: 'You have connected a different account from your primary bank account. Please, make sure you connect to your primary bank account.',
    BANK_STATEMENTS_PARTNER: 'We will contact you as soon as we review your application.',
    JUMIA_OFFER_LETTER_PARTNER: 'In order for us to proceed, please accept the offer letter in Jumia as well.',
    PARTNERSHIP_BANK_STATEMENTS_PARTNER: 'We have received your loan application and are currently reviewing it.',
    PARTNERSHIP_OFFER_LETTER_PARTNER: 'Your offer letter response was registered.',
};
// provider status
exports.NO_MATCH = 'NO_MATCH';
exports.MATCH = 'MATCH';
exports.EMPTY = 'EMPTY';
// provider widget messages
exports.WIDGET_MESSAGES = {
    CONNECTED_SUCCESSFUL: 'Your primary bank has been connected successfully',
    CLICK_TO_CONNECT: 'Click here to connect your primary bank account',
    CLICK_FOR_MBS: 'Click here to add a bank account and request\n your bank statement automatically',
    CLICK_FOR_MBS_WEB: 'Click here to add a bank account and request your bank statement automatically',
};
exports.LOAN_TERMS_WEBSITE_URL = 'https://lendigo.ng/get-to-know-our-loan-terms/';
